import { render, staticRenderFns } from "./coring-desc.vue?vue&type=template&id=948ee918&scoped=true"
import script from "./coring-desc.vue?vue&type=script&lang=js"
export * from "./coring-desc.vue?vue&type=script&lang=js"
import style0 from "./coring-desc.vue?vue&type=style&index=0&id=948ee918&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948ee918",
  null
  
)

export default component.exports